import { CLIENT_ROLES } from "@/constants/components/sidebar";
import { selectSidebarOptionFromUrl, SidebarAction } from "@/imports-files/components/sidebar";

export class SubsidebarAction
{
    constructor(navbarStatus, router, setPageKey, updateNavbarStatus, setSubsidebarOptions, OPTIONS)
    { 
        this.sidebarAction          =    new SidebarAction();
        this.navbarStatus           =    navbarStatus;
        this.router                 =    router;
        this.setPageKey             =    setPageKey;
        this.updateNavbarStatus     =    updateNavbarStatus;
        this.setSubsidebarOptions   =    setSubsidebarOptions;
        this.OPTIONS                =    OPTIONS;
    }

    handle_setting_subsidebar()
    {
        var value = '' ;
        var url   = '' ;
        var key   = JSON.parse(localStorage.getItem('navbarStatus')).key;

        if( key != 'settings')
        {
            value = selectSidebarOptionFromUrl( this.router.asPath)
            url = this.router.asPath;
        }
        else
        {
            value = selectSidebarOptionFromUrl( '/settings')
            url = '/settings';
        }
        this.setPageKey(value.key);
        this.updateNavbarStatus(value);
        this.sidebarAction.deactiveAllSidebarOption();
        this.sidebarAction.activateSidebarOption(document.getElementById(value.key));
        this.sidebarAction.activateSubsidebar( this.OPTIONS[value.key], value.key , value, url);
        this.setSubsidebarOptions(this.OPTIONS[key]['subSidebar_options']);
    }

    handle_setting_subsidebar_firstload()
    {
        var value = selectSidebarOptionFromUrl(this.router.asPath);
        var url   = this.router.asPath;
        var key   = value.key;
        this.setPageKey(value.key);
        this.updateNavbarStatus(value);
        this.sidebarAction.deactiveAllSidebarOption();
        this.sidebarAction.activateSidebarOption(document.getElementById(value.key));
        this.sidebarAction.activateSubsidebar( this.OPTIONS[value.key], value.key , value, url);
        this.setSubsidebarOptions(this.OPTIONS[key]['subSidebar_options']);
    }

    setSubSidarSequence( options, user_role)
    {
        var navbarStatus            =  JSON.parse(localStorage.getItem('navbarStatus'));
        var key                     =  navbarStatus.key; 
        var is_activity_option      =  options == null ? false : Object.keys(options).includes('my_account');
        var client_user_option_key  =  ["my_account", "my_preferences", "my_integrations", "company_integrations", "careers_page"]
        var new_option_hash         = {};
       
        if( is_activity_option && (user_role == CLIENT_ROLES.CLIENT_USER || user_role == CLIENT_ROLES.REVIEWER) && options != null )
        {
            for(let option_key of client_user_option_key)
            {
                new_option_hash[option_key] = options[option_key]
            
            }
            return new_option_hash;
        }
        else
        {
            return options;
        }
        
    }

    setSubsidebarClass()
    {
        if(this.router.asPath.includes('/clients/reports/'))
        {
            return 'ReportsSidebar';
        }
        else{
            return'';
        }
    }
}